// @flow

type TAPIErrorOptions = {
  type: ?string,
  sub_type: ?string,
  code: number,
  message: ?string,
  status?: number,
};

export default class APIError extends Error {
  type: ?string;
  sub_type: ?string;
  code: number;
  message: ?string;

  constructor(options: TAPIErrorOptions) {
    super();
    this.type = options.type;
    this.sub_type = options.sub_type;
    this.code = options.code;
    this.message = options.message;
    Error.captureStackTrace(this, this.constructor);
  }

  static initFromResponse(response: { message: ?string, data: ?{ error: TAPIErrorOptions }, status: number }): APIError {
    const type = response.data
      ? response.data.error
        ? response.data.error.type
        : null
      : null;
    const sub_type = response.data
      ? response.data.error
        ? response.data.error.sub_type
        : null
      : null;
    const code = response.data
      ? response.data.error
        ? response.data.error.code
        : response.status
      : response.status;
    const message = response.data
      ? response.data.error
        ? response.data.error.message
        : response.message
      : response.message;

    return new APIError({ type, sub_type, code, message });
  }

  toObject(): TAPIErrorOptions {
    return {
      type: this.type,
      sub_type: this.sub_type,
      code: this.code,
      message: this.message,
      // stack: this.stack,
    };
  }
}
